import { Injectable } from '@angular/core';
import { AppConstants } from 'src/app-constants';
import { AccountClient } from '../clients/account.client';
import { ApiRequest } from '../service-models/api-contracts/base/api-request';
import { ApiResponse } from '../service-models/api-contracts/base/api-response';
import { RoleTypeSM } from '../service-models/enums/role-type-s-m.enum';
import { SignUpSM } from '../service-models/sign-up.s-m';
import { TokenRequestSM } from '../service-models/token/token-request-s-m';
import { TokenResponseSM } from '../service-models/token/token-response-s-m';
import { LoginViewModel } from '../view-models/login.viewmodel';
import { BaseService } from './base.service';
import { StorageService } from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class AccountService extends BaseService {
  constructor(private accountClient: AccountClient,
    private storageService: StorageService) {
    super();
  }

  async generateToken(tokenReq: TokenRequestSM, loginViewModel: LoginViewModel): Promise<ApiResponse<TokenResponseSM>> {
    if (tokenReq == null || tokenReq.loginId == null)// null checks
    {
      throw new Error(AppConstants.ErrorPrompts.Invalid_Input_Data);
    }
    else {
      let apiRequest = new ApiRequest<TokenRequestSM>();
      tokenReq.companyCode = '123';
      tokenReq.roleType = RoleTypeSM.ClientAdmin;
      apiRequest.reqData = tokenReq;
      var resp = await this.accountClient.GenerateToken(apiRequest);
      if (resp == null || resp.successData.accessToken == '') {
        return resp;
      } else if (loginViewModel.rememberMe == true) {
        // save to local storage
        this.storageService.setToStorage(AppConstants.DbKeys.ACCESS_TOKEN, resp.successData.accessToken);
        this.storageService.setToStorage(AppConstants.DbKeys.LOGIN_USER, resp.successData.loginUserDetails);
        this.storageService.setToStorage(AppConstants.DbKeys.LOGIN_USER, resp.successData.expiresUtc);
        this.storageService.setToStorage(AppConstants.DbKeys.LOGIN_USER, resp.successData.clientCompantId);
        this.storageService.setToStorage(AppConstants.DbKeys.REMEMBER_ME, loginViewModel.rememberMe)
        return resp;
      } else if (loginViewModel.rememberMe == false) {
        // save to session storage
        this.storageService.saveToSessionStorage(AppConstants.DbKeys.ACCESS_TOKEN, resp.successData.accessToken);
        this.storageService.saveToSessionStorage(AppConstants.DbKeys.TOKEN_EXPIRY, resp.successData.expiresUtc.toString());
        this.storageService.saveToSessionStorage(AppConstants.DbKeys.LOGIN_USER, JSON.stringify(resp.successData.loginUserDetails));
        this.storageService.saveToSessionStorage(AppConstants.DbKeys.COMPANY_CODE, resp.successData.clientCompantId)
        this.storageService.saveToSessionStorage(AppConstants.DbKeys.REMEMBER_ME, JSON.stringify(loginViewModel.rememberMe));
        return resp;

      }
      return resp;
    }
  }


  async registerUser(signUpServiceModel: SignUpSM): Promise<ApiResponse<SignUpSM>> {
    if (signUpServiceModel == null) {
      throw new Error(AppConstants.ErrorPrompts.Invalid_Input_Data);
    }

    else {
      let apiRequest = new ApiRequest<SignUpSM>();
      apiRequest.reqData = signUpServiceModel;
      return this.accountClient.RegisterUser(apiRequest);

    }
  }
  async logoutUser() {
    try {
      this.storageService.removeFromSessionStorage(AppConstants.DbKeys.ACCESS_TOKEN);
      this.storageService.removeFromSessionStorage(AppConstants.DbKeys.LOGIN_USER);
      this.storageService.removeFromSessionStorage(AppConstants.DbKeys.COMPANY_CODE);
      this.storageService.removeFromSessionStorage(AppConstants.DbKeys.REMEMBER_PWD);
    }
    catch (err) {
      this.storageService.clearSessionStorage();
    }
    try {
      this.storageService.removeFromStorage(AppConstants.DbKeys.ACCESS_TOKEN);
      this.storageService.removeFromStorage(AppConstants.DbKeys.LOGIN_USER);
      this.storageService.removeFromStorage(AppConstants.DbKeys.COMPANY_CODE);
      this.storageService.removeFromStorage(AppConstants.DbKeys.REMEMBER_PWD);
    } catch (error) {
      this.storageService.clearStorage();
    }

  }

}

